export const SmartFilterChipColorType = {
  Transparent: 'transparent',
  White: 'white',
  Gray: 'gray',
  Primary: 'primary',
  Orange: 'orange',
  Green: 'green',
  Red: 'red',
  Purple: 'purple',
  Yellow: 'yellow',
} as const;
export type SmartFilterChipColorType =
  (typeof SmartFilterChipColorType)[keyof typeof SmartFilterChipColorType];

export type SmartFilterChipSizeType = 'small' | 'xs';
